import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Alert,
} from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  width: { xs: "90%", sm: "80%", md: "60%" },
  maxHeight: "90vh",
  overflowY: "auto",
};

// Add Fournisseur Modal
export const AddFournisseurModal = ({
  open,
  handleClose,
  handleSubmit,
  fournisseurData,
  handleChange,
  categories = [],
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ mb: 3, color: "primary.main" }}
        >
          Ajouter un nouveau fournisseur
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Catégorie</InputLabel>
                <Select
                  name="categorie_code"
                  value={fournisseurData.categorie_code || ""}
                  onChange={handleChange}
                  required
                >
                  {Array.isArray(categories) &&
                    categories.map((cat) => (
                      <MenuItem key={cat.Code} value={cat.Code}>
                        {cat.Code}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Raison Sociale"
                name="raison_sociale"
                value={fournisseurData.raison_sociale || ""}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={fournisseurData.email || ""}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Téléphone"
                name="telephone"
                value={fournisseurData.telephone || ""}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Site Web"
                name="site_web"
                value={fournisseurData.site_web || ""}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Numéro Fiscal"
                name="numero_fiscal"
                value={fournisseurData.numero_fiscal || ""}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Adresse"
                name="adresse"
                value={fournisseurData.adresse || ""}
                onChange={handleChange}
                multiline
                rows={2}
                required
              />
            </Grid>
          </Grid>

          <Box
            sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button variant="outlined" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="contained" type="submit" color="secondary">
              Enregistrer
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

// Edit Fournisseur Modal with the same fixes
export const EditFournisseurModal = ({
  open,
  handleClose,
  handleSubmit,
  fournisseurData,
  handleChange,
  categories = [],
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ mb: 3, color: "primary.main" }}
        >
          Modifier le fournisseur
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Catégorie</InputLabel>
                <Select
                  name="categorie_code"
                  value={fournisseurData.categorie_code || ""}
                  onChange={handleChange}
                  required
                >
                  {Array.isArray(categories) &&
                    categories.map((cat) => (
                      <MenuItem key={cat.Code} value={cat.Code}>
                        {cat.Code}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            {/* ... Other fields with null checks ... */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Raison Sociale"
                name="raison_sociale"
                value={fournisseurData.raison_sociale || ""}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={fournisseurData.email || ""}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Téléphone"
                name="telephone"
                value={fournisseurData.telephone || ""}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Site Web"
                name="site_web"
                value={fournisseurData.site_web || ""}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Numéro Fiscal"
                name="numero_fiscal"
                value={fournisseurData.numero_fiscal || ""}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Adresse"
                name="adresse"
                value={fournisseurData.adresse || ""}
                onChange={handleChange}
                multiline
                rows={2}
                required
              />
            </Grid>
          </Grid>

          <Box
            sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button variant="outlined" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="contained" type="submit" color="secondary">
              Mettre à jour
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

// Delete Fournisseur Modal remains the same
export const DeleteFournisseurModal = ({
  open,
  handleClose,
  handleDelete,
  fournisseur = {},
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h6"
          component="h2"
          sx={{ mb: 3, color: "error.main" }}
        >
          Confirmer la suppression
        </Typography>

        <Alert severity="warning" sx={{ mb: 3 }}>
          Êtes-vous sûr de vouloir supprimer le fournisseur suivant ?
        </Alert>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Code Fournisseur:</strong>{" "}
          {fournisseur.Code_Fournisseur || ""}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Raison Sociale:</strong> {fournisseur.raison_sociale || ""}{" "}
          {fournisseur.preraison_sociale || ""}
        </Typography>

        <Box
          sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button variant="outlined" onClick={handleClose}>
            Annuler
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Supprimer
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
